import PageHeader from "@/components/PageHeader";
import AccountPage from "./AccountPage";

export default function AccountSettingsHubPage() {
  return (
    <div className="space-y-10">
      <PageHeader
        title="Account & Settings"
        description="Manage your profile, organization, security, and linked profiles from a single place."
      />
      <div className="space-y-12">
        <AccountPage showHeader={false} />
      </div>
    </div>
  );
}
